<template>
    <v-card variant="outlined" class="pa-3 bg-white">
        <v-card-title class="text-body-2 d-flex align-center">
            <v-icon v-if="isEditMode" size="small" class="mr-1">mdi-pencil</v-icon>
            {{ isEditMode ? $t('rating.editTitle') : $t('rating.title') }}
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="4">
                    <div class="text-caption text-medium-emphasis mb-1">{{ $t('rating.general') }}</div>
                    <v-rating
                        v-model="ratingGeneral"
                        :length="5"
                        size="small"
                        color="amber"
                        density="compact"
                        hover
                    />
                </v-col>
                <v-col cols="12" md="4">
                    <div class="text-caption text-medium-emphasis mb-1">{{ $t('rating.communication') }}</div>
                    <v-rating
                        v-model="ratingCommunication"
                        :length="5"
                        size="small"
                        color="amber"
                        density="compact"
                        hover
                    />
                </v-col>
                <v-col cols="12" md="4">
                    <div class="text-caption text-medium-emphasis mb-1">{{ $t('rating.deliveryTime') }}</div>
                    <v-rating
                        v-model="ratingDeliveryTime"
                        :length="5"
                        size="small"
                        color="amber"
                        density="compact"
                        hover
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="px-3 pb-3 pt-0">
            <v-row dense class="w-100 ma-0">
                <v-col cols="6" class="pa-1">
                    <v-btn block variant="flat" color="error" @click="$emit('cancel')">
                        {{ $t('common.cancel') }}
                    </v-btn>
                </v-col>
                <v-col cols="6" class="pa-1">
                    <v-btn block variant="flat" color="primary" :loading="loading" @click="submit">
                        {{ isEditMode ? $t('rating.update') : $t('rating.submit') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from "axios";
import { showAlertModal } from "@/utils";

export default {
    name: "RatingForm",
    props: {
        ratedCompanyId: { type: Number, required: true },
        reservationUid: { type: String, required: true },
        existingRating: { type: Object, default: null },
        initialStars: { type: Number, default: 0 },
        mode: { type: String, default: "create", validator: (value) => ["create", "edit"].includes(value) },
    },
    emits: ["rated", "cancel"],
    data() {
        return {
            ratingGeneral: 0,
            ratingCommunication: 0,
            ratingDeliveryTime: 0,
            loading: false,
        };
    },
    computed: {
        isEditMode() {
            return this.mode === "edit" && this.existingRating;
        },
    },
    watch: {
        existingRating: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.ratingGeneral = val.rating_general ?? 0;
                    this.ratingCommunication = val.rating_communication ?? 0;
                    this.ratingDeliveryTime = val.rating_delivery_time ?? 0;
                }
            },
        },
        initialStars: {
            immediate: true,
            handler(val) {
                if (this.mode === "create" && !this.existingRating && val >= 1 && val <= 5) {
                    this.ratingGeneral = val;
                    this.ratingCommunication = val;
                    this.ratingDeliveryTime = val;
                }
            },
        },
    },
    methods: {
        async submit() {
            if (this.ratingGeneral < 1 || this.ratingCommunication < 1 || this.ratingDeliveryTime < 1) {
                showAlertModal(this.$store, this.$t("rating.pleaseSelect"), "warning", 3000);
                return;
            }
            this.loading = true;
            try {
                if (this.isEditMode) {
                    await axios.patch(
                        `${process.env.VUE_APP_API_URL}/ratings/${this.existingRating.id}/`,
                        {
                            rating_general: this.ratingGeneral,
                            rating_communication: this.ratingCommunication,
                            rating_delivery_time: this.ratingDeliveryTime,
                        }
                    );
                } else {
                    await axios.post(`${process.env.VUE_APP_API_URL}/ratings/`, {
                        rated_company_id: this.ratedCompanyId,
                        reservation_uid: this.reservationUid,
                        rating_general: this.ratingGeneral,
                        rating_communication: this.ratingCommunication,
                        rating_delivery_time: this.ratingDeliveryTime,
                        comment: "",
                    });
                }
                this.$emit("rated");
            } catch (err) {
                showAlertModal(
                    this.$store,
                    err.response?.data?.error || "Failed to submit rating",
                    "danger",
                    5000
                );
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
